var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('v-alert',{staticClass:"text-center homepage-flash-message",attrs:{"color":"primary","dark":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.content.rendered)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }